import {FilterOperator} from '@progress/kendo-data-query';

/**
 * Operators offered per filter type for the Access Change Monitoring alerts table.
 * Restricted to the set the alerts endpoint accepts, so the
 * grid can only emit operators the backend supports. Enum columns (predefinedList)
 * offer EqualTo only — the alerts fetch normalizer collapses all enum operators to
 * `in`, so offering "is not equal to" would be misleading.
 */
export const AlertOperatorsByTypeMapping: Record<string, FilterOperator[]> = {
  text: [FilterOperator.Contains, FilterOperator.DoesNotContain],
  numeric: [FilterOperator.EqualTo, FilterOperator.GreaterThan, FilterOperator.LessThan],
  date: [FilterOperator.GreaterThan, FilterOperator.LessThan],
  predefinedList: [FilterOperator.EqualTo]
};
